import React from 'react'
import Svg from "../svg";

const SVGElement = ({name, alt}) => {
  return (<Svg name={name} relativePath={`svgs/${name}.svg`}/>)
}
  
export {SVGElement}